import ReactGA from 'react-ga4';

// Types.
import { GAEvent } from '../types/cookies';

export const gaPageviewIfAllowed = (page: string): void => {
  ReactGA.send({ hitType: 'pageview', page: page });
};

export const gaEventIfAllowed = (gaEvent: GAEvent): void => {
  ReactGA.event(gaEvent);
};
